import React, { useState } from 'react';
import Input from './components/Input';
import Button from './components/Button';
import { Link, useNavigate } from 'react-router-dom';
import { setToken } from './auth';
import { useToast } from './ToastContext';
import { login } from './api';

export default function Login() {
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.email) newErrors.email = 'Email requis';
    if (!form.password) newErrors.password = 'Mot de passe requis';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoading(true);
    try {
      const data = await login(form.email, form.password);
      if (data.access_token) {
        // Vérifier le format du token avant de le stocker
        const tokenSegments = data.access_token.split('.');
        if (tokenSegments.length !== 3) {
          console.error('Token reçu invalide (pas 3 segments):', data.access_token.substring(0, 50) + '...');
          showToast('Erreur: token invalide reçu du serveur', 'error');
          return;
        }
        setToken(data.access_token);
        // Vérifier que le token est bien stocké
        const storedToken = localStorage.getItem('jwt');
        if (storedToken && storedToken === data.access_token) {
          showToast('Connexion réussie !', 'success');
          // Utiliser window.location pour forcer un rechargement complet
          setTimeout(() => {
            window.location.href = '/';
          }, 100);
        } else {
          console.error('Token non stocké correctement. Stored:', storedToken?.substring(0, 30), 'Received:', data.access_token.substring(0, 30));
          showToast('Erreur: token non stocké', 'error');
        }
      } else {
        showToast('Erreur de connexion', 'error');
        setErrors({ global: 'Erreur de connexion' });
      }
    } catch (err) {
      const errorMessage = err.response?.data?.detail || err.message || 'Erreur réseau';
      showToast(errorMessage, 'error');
      setErrors({ global: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <form onSubmit={handleSubmit} className="bg-white/80 shadow-lg rounded-xl p-8 w-full max-w-md flex flex-col gap-4 border border-blue-gray-100">
        <h1 className="font-heading text-2xl mb-2 text-center">Connexion</h1>
        {errors.global && <div className="text-error text-sm text-center">{errors.global}</div>}
        <Input label="Email" name="email" type="email" value={form.email} onChange={handleChange} autoComplete="email" />
        {errors.email && <div className="text-error text-xs">{errors.email}</div>}
        <Input label="Mot de passe" name="password" type="password" value={form.password} onChange={handleChange} autoComplete="current-password" />
        {errors.password && <div className="text-error text-xs">{errors.password}</div>}
        <div className="flex justify-end -mt-2 mb-2">
          <Link to="/forgot-password" className="text-xs text-accent hover:underline font-heading font-normal">Mot de passe oublié ?</Link>
        </div>
        <Button type="submit" disabled={loading} className="w-full mt-2">{loading ? 'Connexion...' : 'Se connecter'}</Button>
        <div className="text-center mt-4 text-xs text-blue-gray-300">
          <Link to="/" className="hover:underline">← Retour à l’accueil</Link>
        </div>
      </form>
    </div>
  );
} 